import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";

const SitePerformance = (props) => {
    document.title = "Site Performance";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [lightHouseDesktopData, setLightHouseDesktopData] = useState({
        columns: [
            {
                label: 'Performance Audit Type',
                field: 'audit',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Score',
                field: 'score',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Display Value',
                field: 'displayValue',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Description',
                field: 'description',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Details',
                field: 'details',
                sort: 'asc',
                width: 150
            },
        ]
    })

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Site Performance", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Site Performance", breadcrumbItems)
    })

    useEffect(() => {
        const getLHDScanList = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SITE_PERFORMANCE_LHD_SCAN}/${scanId}`)
                data.data = data.data.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setLightHouseDesktopData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data
                }))
            } catch (e) {
                console.error(e);
            }
        }
        getLHDScanList()
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <TableHeader scanName={"Light House Desktop"} scanId={scanId} />
                        <CardBody className="search-engine-table">
                            {lightHouseDesktopData && lightHouseDesktopData.rows && (
                                <DataTableWithPopup noBottomColumns={false} thirdPartyData={lightHouseDesktopData} />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(SitePerformance)